module.exports = __webpack_public_path__ + "static/media/slick.b7c9e1e4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/slick.woff
// module id = 340
// module chunks = 0